// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from Calendar.module.scss  */
.Calendar-module-Root_Y6L {
  position: relative;
  display: flex;
  overflow: hidden;
  flex-wrap: wrap;
  box-sizing: border-box;
  font-family: var(--interface-font-family);
  vertical-align: top;
  border: none;
  margin-inline: 0.8rem; }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/Calendar/Calendar.css"],"names":[],"mappings":"AAAA,yCAAyC;AACzC;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,yCAAyC;EACzC,mBAAmB;EACnB,YAAY;EACZ,qBAAqB,EAAE","sourcesContent":["/*  imported from Calendar.module.scss  */\n.Calendar-module-Root_Y6L {\n  position: relative;\n  display: flex;\n  overflow: hidden;\n  flex-wrap: wrap;\n  box-sizing: border-box;\n  font-family: var(--interface-font-family);\n  vertical-align: top;\n  border: none;\n  margin-inline: 0.8rem; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
